import { contains } from 'underscore';
import { PropertyType } from 'FormsUI/lib/Property';
import { MandatoryProperties } from 'forms-utils-lib/constants/Properties';
export function getPropertyId(property) {
  return `${property.propertyObjectType}-${property.name}`;
}
export function getPropertyGroupId(group) {
  return `${group.groupObjectType}-${group.name}`;
}
export function getPropertyObjectTypeId(property) {
  return `${property.objectTypeId}/${property.name}`;
}
export function isSupportedProperty(property) {
  // External option properties are not handled by our UI
  return property.type !== PropertyType.ENUMERATION || property.type === PropertyType.ENUMERATION && !property.externalOptions;
}
export function isMandatoryProperty(formType, objectTypeId, propertyName) {
  return contains((MandatoryProperties[formType] || {})[objectTypeId] || [], propertyName);
}
export const updateMapKeysForUsingObjectTypes = fieldsMap => fieldsMap.mapKeys((__, {
  field
}) => `${field.objectTypeId}/${field.name}`);